import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select, { SelectProps } from '@material-ui/core/Select';
import styles from './styles.module.css';

const MenuProps  = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      boxShadow: ' 0px 5px 15px 0px rgba(0, 0, 0, 0.20)',
    },
  },
  MenuListProps: {
    style: {
      padding: '20px 20px 0 20px',
    },
  },
};

type Props = SelectProps & {
  className?: string;
  errorMessage?: string;
  children: any;
  iconStart?: any;
  iconEnd?: any;
};

const SelectBase = ({ className, error, errorMessage, iconStart, iconEnd, children, ...restProps }: Props) => {
  return (
    <>
      <Select
        error={error}
        className={styles.select}
        fullWidth
        displayEmpty
        variant="outlined"
        MenuProps={{
          ...MenuProps,
        }}
        {...(iconStart && {
          startAdornment: (
            <InputAdornment position="start" className={styles.input_icon}>
              <div className={styles.inputIcon}>{iconStart}</div>
            </InputAdornment>
          ),
        })}
        {...(iconEnd && {
          IconComponent: () => <div className={styles.icon}>{iconEnd}</div>,
        })}
        {...restProps}
      >
        {children}
      </Select>
      {errorMessage && <FormHelperText className={styles.textError}>{errorMessage}</FormHelperText>}
    </>
  );
};

export default SelectBase;
